import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { usePayrollQuery } from "./usePayrollQuery";
import { usePayrollParams } from "./usePayrollParams";
import {
  PAYROLL_STATUS_CLOSED,
  PAYROLL_STATUS_CREATED,
  PAYROLL_STATUS_PREVIEW,
  PAYROLL_STATUS_SPLIT,
  PAYROLL_VERSION_CORRECTION,
} from "@/schemas/payroll";

export const usePayrollPermissions = () => {
  const { payrollId } = usePayrollParams();
  const permissions = useModulePermissions(Module.Payrolls);
  const payrollQuery = usePayrollQuery(payrollId);

  const { payroll_status, payroll_version, split } = payrollQuery.data ?? {};

  const isInPreviewStatus = payroll_status === PAYROLL_STATUS_PREVIEW;
  const isInCreatedStatus = payroll_status === PAYROLL_STATUS_CREATED;
  const isInSplitStatus = payroll_status === PAYROLL_STATUS_SPLIT;
  const isInClosedStatus = payroll_status === PAYROLL_STATUS_CLOSED;
  const isInCorrectionVersion = payroll_version === PAYROLL_VERSION_CORRECTION;

  const can_update =
    permissions.can_update && !isInClosedStatus && !isInPreviewStatus;

  return {
    isLoading: payrollQuery.isLoading,
    canAccessPreview: isInPreviewStatus,
    canAccessSplit: isInSplitStatus || (split && isInClosedStatus),
    canAccessAggregation: !isInPreviewStatus,
    canAccessInspection: !isInPreviewStatus,
    canCloseSplit: split && isInSplitStatus,
    canCloseAggregate: !split && isInCreatedStatus,
    canCorrect: isInClosedStatus && !isInCorrectionVersion,
    canSplit: split && isInCreatedStatus && !isInClosedStatus,
    canUpdateAggregate: permissions.can_update && isInCreatedStatus,
    canUpdateInspection: permissions.can_update && isInCreatedStatus,
    isInPreviewStatus,
    isInCreatedStatus,
    isInSplitStatus,
    isInClosedStatus,
    ...permissions,
    can_update,
  };
};
